import { ICauHinhLoaiDichVuItemRequest } from '../../../models/request/dich-vu/cauHinhLoaiDichVuRequests';
import { IDichVuSelectRequest } from '../../../models/request/dich-vu/dichVuRequests';
import { CauHinhLoaiDichVuItemResponse } from '../../../models/response/dich-vu/sf_cauhinh_loaidichvu';
import { sf_loaidichvu } from '../../../models/response/dich-vu/sf_loaidichvu';

export enum eCauHinhLoaiDichVuActionTypeIds {
	LOAD_START = "CAUHINH_LOAIDICHVU_LOAD_START",
	LOAD_SUCCESS = "CAUHINH_LOAIDICHVU_LOAD_SUCCESS",
	LOAD_ERROR = "CAUHINH_LOAIDICHVU_LOAD_ERROR",

	LOAD_LOAIDICHVU_START = "CAUHINH_LOAIDICHVU_LOAD_LOAIDICHVU_START",
	LOAD_LOAIDICHVU_SUCCESS = "CAUHINH_LOAIDICHVU_LOAD_LOAIDICHVU_SUCCESS",
	LOAD_LOAIDICHVU_ERROR = "CAUHINH_LOAIDICHVU_LOAD_LOAIDICHVU_ERROR",

	LOAD_DETAIL_START = "CAUHINH_LOAIDICHVU_LOAD_DETAIL_START",
	LOAD_DETAIL_SUCCESS = "CAUHINH_LOAIDICHVU_LOAD_DETAIL_SUCCESS",
	LOAD_DETAIL_ERROR = "CAUHINH_LOAIDICHVU_LOAD_DETAIL_ERROR",

	SHOW_DETAIL = "CAUHINH_LOAIDICHVU_SHOW_DETAIL",
	CLOSE_DETAIL = "CAUHINH_LOAIDICHVU_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "CAUHINH_LOAIDICHVU_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "CAUHINH_LOAIDICHVU_SHOW_CONFIRM",
	CLOSE_CONFIRM = "CAUHINH_LOAIDICHVU_CLOSE_CONFIRM",

	SAVE_START = "CAUHINH_LOAIDICHVU_SAVE_START",
	SAVE_SUCCESS = "CAUHINH_LOAIDICHVU_SAVE_SUCCESS",
	SAVE_ERROR = "CAUHINH_LOAIDICHVU_SAVE_ERROR",

	DELETE_START = "CAUHINH_LOAIDICHVU_DELETE_START",
	DELETE_SUCCESS = "CAUHINH_LOAIDICHVU_DELETE_SUCCESS",
	DELETE_ERROR = "CAUHINH_LOAIDICHVU_DELETE_ERROR"
}

export interface ICauHinhLoaiDichVuLoadStart {
	type: eCauHinhLoaiDichVuActionTypeIds.LOAD_START,
	payload: IDichVuSelectRequest
}
export interface ICauHinhLoaiDichVuLoadSuccess {
	type: eCauHinhLoaiDichVuActionTypeIds.LOAD_SUCCESS,
	payload: CauHinhLoaiDichVuItemResponse[]
}
export interface ICauHinhLoaiDichVuLoadErr {
	type: eCauHinhLoaiDichVuActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface ILoaiDichVuLoadStart {
	type: eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_START
}
export interface ILoaiDichVuLoadSuccess {
	type: eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_SUCCESS,
	payload: sf_loaidichvu[]
}
export interface ILoaiDichVuLoadErr {
	type: eCauHinhLoaiDichVuActionTypeIds.LOAD_LOAIDICHVU_ERROR,
	payload: string
}
export interface ICauHinhLoaiDichVuLoadDetailStart {
	type: eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_START,
	payload: number
}
export interface ICauHinhLoaiDichVuLoadDetailSuccess {
	type: eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_SUCCESS,
	payload: CauHinhLoaiDichVuItemResponse
}
export interface ICauHinhLoaiDichVuLoadDetailErr {
	type: eCauHinhLoaiDichVuActionTypeIds.LOAD_DETAIL_ERROR,
	payload: string
}
export interface ICauHinhLoaiDichVuShowDetail {
	type: eCauHinhLoaiDichVuActionTypeIds.SHOW_DETAIL,
	payload?: CauHinhLoaiDichVuItemResponse
}
export interface ICauHinhLoaiDichVuCloseDetail {
	type: eCauHinhLoaiDichVuActionTypeIds.CLOSE_DETAIL
}
export interface ICauHinhLoaiDichVuChangeSelectedIds {
	type: eCauHinhLoaiDichVuActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface ICauHinhLoaiDichVuShowConfirm {
	type: eCauHinhLoaiDichVuActionTypeIds.SHOW_CONFIRM
}
export interface ICauHinhLoaiDichVuCloseConfirm {
	type: eCauHinhLoaiDichVuActionTypeIds.CLOSE_CONFIRM
}
export interface ICauHinhLoaiDichVuSaveStart {
	type: eCauHinhLoaiDichVuActionTypeIds.SAVE_START,
	payload: ICauHinhLoaiDichVuItemRequest
}
export interface ICauHinhLoaiDichVuSaveSuccess {
	type: eCauHinhLoaiDichVuActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface ICauHinhLoaiDichVuSaveErr {
	type: eCauHinhLoaiDichVuActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface ICauHinhLoaiDichVuDeleteStart {
	type: eCauHinhLoaiDichVuActionTypeIds.DELETE_START,
	payload: number
}
export interface ICauHinhLoaiDichVuDeleteSuccess {
	type: eCauHinhLoaiDichVuActionTypeIds.DELETE_SUCCESS
}
export interface ICauHinhLoaiDichVuDeleteErr {
	type: eCauHinhLoaiDichVuActionTypeIds.DELETE_ERROR,
	payload: string
}

export type ICauHinhLoaiDichVuActionTypes = ICauHinhLoaiDichVuLoadStart | ICauHinhLoaiDichVuLoadSuccess | ICauHinhLoaiDichVuLoadErr |
	ILoaiDichVuLoadStart | ILoaiDichVuLoadSuccess | ILoaiDichVuLoadErr |
	ICauHinhLoaiDichVuLoadDetailStart | ICauHinhLoaiDichVuLoadDetailSuccess | ICauHinhLoaiDichVuLoadDetailErr |
	ICauHinhLoaiDichVuShowDetail | ICauHinhLoaiDichVuCloseDetail |
	ICauHinhLoaiDichVuChangeSelectedIds |
	ICauHinhLoaiDichVuShowConfirm | ICauHinhLoaiDichVuCloseConfirm |
	ICauHinhLoaiDichVuSaveStart | ICauHinhLoaiDichVuSaveSuccess | ICauHinhLoaiDichVuSaveErr |
	ICauHinhLoaiDichVuDeleteStart | ICauHinhLoaiDichVuDeleteSuccess | ICauHinhLoaiDichVuDeleteErr
